<template>
  <div id="RentalSection">
    <section class="section" style="background-color: #0a0a0a;">
      <div class="container">
        <h1 class="title" style="color: white;">RENTAL SPACE</h1>
        <div class="columns is-gapless is-multiline is-tablet is-mobile">
          <div class="column is-12">
            <img
              src="../assets/rentals/rental_space.jpg"
              alt="rental space detail"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "RentalSection"
};
</script>

<style></style>
